import { Injector } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { TreeNodeAliasTranslation } from "../Entity/TreeNodeAliasTranslation";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeMedicinalProductsAliasTranslation extends Art57NodeList{
    items: any;
    cloningNode: boolean = false;
    constructor(injector: Injector, parent: any, cloningNode: boolean, items: any[]|undefined) {
        super(injector, new ListView(), `Alias Translations (${items?items.length:'-'})`);
        this.parent = parent;
        this.cloningNode = cloningNode;
        this.labelNodeName = 'Alias Translations'
        this.items = items;

        if (this.cloningNode) {
            return;
        }
        for (const item of items || []) {
            this.children?.push(new TreeNodeAliasTranslation(injector,item,this));
        }
    }

    override getHeaders(): string[] {
        return ['Language Code', 'Translation'];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsAliasTranslation = new TreeNodeMedicinalProductsAliasTranslation(this.ioc!,newParent, true, this.items);        
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }    

}